module.exports = __webpack_public_path__ + "static/media/249-democratic-republic-of-congo.6424746d.svg";